export default __webpack_public_path__ + "static/media/qr-code-scan.cfcff28d.svg";